import { initialDiagnosisState } from '../../../features/diagnosis/store/diagnosis.reducers'
import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { moveElementToPath } from '../../object.util'

export const moveInitialPatientAcuity = (pcr: any): IPcr => {
  try {
    if (!pcr.diagnosis && pcr.situation && pcr.situation.initialPatientAcuity) {
      pcr.diagnosis = { ...initialDiagnosisState }
      moveElementToPath(pcr, 'situation.initialPatientAcuity', 'diagnosis.initialPatientAcuity')
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule moveInitialPatientAcuity ${error}`)
    throw error
  }
}
